import { ILoginResponse } from '@aqx-core/common/api/auth';
import { ICentroidLoginMobileParams, ICentroidLoginWebParams } from '@aqx-core/common/api/centroid-login';
import { request } from '@aqx-core/common/request';

export default {
  loginWebCentroidDemo: (params: ICentroidLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/centroid/demo/login', params),
  loginMobileCentroidDemo: (params: ICentroidLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/centroid/demo/mobile/login', params),
  loginWebCentroidLive: (params: ICentroidLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/centroid/live/login', params),
  loginMobileCentroidLive: (params: ICentroidLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/centroid/live/mobile/login', params)
};
